function LogByTypeFactory(type = '', level = '', name, args = []) {
    const lvl = CreateLogger.levels[level];
    const lvlRegExp = new RegExp(`^(${lvl})$`)
    let history = CreateLogger.history;
    if (type !== 'log') {
        args.unshift(type.toUpperCase() + ':')
    }
    args.unshift(name + ':');
    if (Array.isArray(history)) {
        history.push([].concat(args));
        const splice = history.length - 1000;
        history.splice(0, splice > 0 ? splice : 0);
    }
    if (!window.console) {
        return;
    }
    let fn
    if (type === 'debug') {
        fn = window.console.info || window.console.log;
    } else {
        fn = window.console[type];
    }
    if (!fn || !lvl || !lvlRegExp.test(type)) {
        return;
    }
    fn[Array.isArray(args) ? 'apply' : 'call'](window.console, args);
}

class CreateLogger {
    static levels = {
        all: 'debug|log|warn|error',
        off: '',
        debug: 'debug|log|warn|error',
        info: 'log|warn|error',
        warn: 'warn|error',
        error: 'error',
        // DEFAULT: level
    }
    static history = []
    level = 'info'

    constructor(name) {
        this.name = name || 'CreateLogger'
    }

    log(...args) {
        LogByTypeFactory('log', this.level, this.name, args)
    }

    error(...args) {
        LogByTypeFactory('error', this.level, this.name, args)
    }

    warn(...args) {
        LogByTypeFactory('warn', this.level, this.name, args)
    }

    debug(...args) {
        LogByTypeFactory('debug', this.level, this.name, args)
    }

    addLogger(subName = '') {
        this.name = subName
    }

    history = {
        all: () => {
            return CreateLogger.history();
        },
        filter: (fname) => {
            return (CreateLogger.history || []).filter((historyItem) => {
                return new RegExp(`.*${fname}.*`).test(historyItem[0]);
            });
        },
        clear: () => {
            if (Array.isArray(CreateLogger.history)) {
                CreateLogger.history.length = 0;
            }
        },
        disable: () => {
            if (Array.isArray(CreateLogger.history)) {
                CreateLogger.history.length = 0;
                CreateLogger.history = null
            }
        },
        enable: () => {
            if (!Array.isArray(CreateLogger.history)) {
                CreateLogger.history = []
            }
        },
    }

    setlevel(lvl = 'info') {
        const levels = CreateLogger.levels
        if (typeof lvl === 'string') {
            if (!levels.hasOwnProperty(lvl)) {
                throw new Error(`"${lvl}" in not a valid log level`);
            }
            this.level = lvl
        }
        return this.level
    }
}
const Log = new CreateLogger('LIVE-APP-H5');
if (process.env.REACT_APP_MODE === 'development' || process.env.REACT_APP_MODE === 'test' || process.env.REACT_APP_MODE === 'preprod') {
    Log.setlevel('all')
} else {
    Log.setlevel('off')
}
window.Log = Log;
window.$Log = Log;
export default Log